import { render, staticRenderFns } from "./BuildList.vue?vue&type=template&id=f9f77288"
import script from "./BuildList.vue?vue&type=script&lang=js"
export * from "./BuildList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports